import type { Session } from 'next-auth';

import { REFRESH_TOKEN_ERROR } from './constants';

/** A session whose refresh token Keycloak will not exchange: signed in, but nothing read with it
 * can be trusted. Every gate that has to stand down asks this one question. */
export const isSessionExpired = (session: Session | null | undefined) => session?.error === REFRESH_TOKEN_ERROR;

type Listener = () => void;

const listeners = new Set<Listener>();

/**
 * Lets the API client tell the React tree that the session is beyond repair, without importing React
 * into `services/api.ts` or routing the signal through a provider the server bundle would also load.
 */
export const subscribeSessionExpired = (listener: Listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const notifySessionExpired = () => {
  for (const listener of listeners) listener();
};
